var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03571 6.42885C3.03571 6.13298 3.27556 5.89314 3.57143 5.89314H7.32143V13.3931H3.03571V6.42885Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.07143
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6783 8.0362H16.4283C16.7242 8.0362 16.964 8.27605 16.964 8.57192V13.3933H12.6783V8.0362Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.07143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32087 2.1432C7.32087 1.84734 7.56072 1.60749 7.85658 1.60749H12.1423C12.4382 1.60749 12.678 1.84734 12.678 2.14321V13.3932H7.32087V2.1432Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.07143
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/navIcon-4.c3d289adb26588f7c2ab07794b0b800c.svg";
export { ForwardRef as ReactComponent };